import React from 'react';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { ButtonDropdown, DropdownMenu, DropdownItem, DropdownToggle } from 'reactstrap';
import * as utility from '../data/Utility';


class DropdownSelection extends React.Component {
	constructor(props) {
		super(props);

		var theSelections = props.selections && props.selections.map(Function.prototype.call, String.prototype.trim);

		const initialSelection = props.values && props.values[0];

		this.state = {
			onSelect: props.onSelect,
			className: props.className,
			isCheckboxes: utility.propCheck( props.isCheckboxes, false ),
			dropdownOpen: false,
			valueObjects: this.convertValueObjects(props.values),
			selectionArray: theSelections,
			valueRadio : initialSelection
		};

		this.toggle = this.toggle.bind(this);
		this.selectRadio = this.selectRadio.bind(this);
		this.selectCheckbox = this.selectCheckbox.bind(this);
	}

	componentDidUpdate( prevProps ) {
		if ((prevProps && prevProps.values) !== this.props.values) {
			this.setState({ valueObjects: this.convertValueObjects(this.props.values) });
		}
	}

	convertValueObjects( values ) {
		var theValues = values;
		if ( typeof theValues === "object" ) {
			if ( theValues && theValues.length > 0 && theValues[0] && ! theValues[0].hasOwnProperty("label") ) { 
				theValues = theValues.map( function( selection, idx ) { return { "label": selection.trim(), "value": selection.trim() }; }, this);
			}
		} else {
			if ( values ) {
				const val = values;
				theValues = [{ "label": val.trim(), "value": val.trim() }];
			} else {
				theValues = [];
			}
		}
		return theValues;
	}
  
	toggle() {
		this.setState({
		  dropdownOpen: !this.state.dropdownOpen
		});
	}

	selectRadio( evt ) {

		const textChosen = evt.target.innerText;

		this.setState({
		  dropdownOpen: !this.state.dropdownOpen,
		  valueRadio: textChosen
		});

		this.state.onSelect( [textChosen] );
	}

	selectCheckbox( valuesChosen ) {

		this.setState({
		  dropdownOpen: !this.state.dropdownOpen,
		  valueObjects:  valuesChosen 
		});

		const valuesArray = Object.keys(valuesChosen).map((k) => valuesChosen[k].label);

		this.state.onSelect( valuesArray );
	}


	render() {
		let optionsObject = this.state.selectionArray.map( function( selection, idx ) { return { "label": selection, "value": selection }; }, this);

		if ( this.state.isCheckboxes ) {
			return ( <ReactMultiSelectCheckboxes id={this.props.id} onChange={this.selectCheckbox} options={optionsObject} value={this.state.valueObjects} /> );
		} else {

			const selectFunc = this.selectRadio;

			return (
			  <div className={this.state.className}>
				<ButtonDropdown className="dropdown-radio" isOpen={this.state.dropdownOpen} toggle={this.toggle}>
				<DropdownToggle id={this.props.id} disabled={this.props.disabled} className="dropdown-hcs dropdown-radio" caret> {this.state.valueRadio} </DropdownToggle>
				<DropdownMenu className="dropdown-radio">
					{ this.state.selectionArray.map( function( selection, idx ) { return <DropdownItem key={"dropdown" + idx} onClick={selectFunc}> {selection} </DropdownItem> }, this) }
				</DropdownMenu>
			  </ButtonDropdown>
			  </div>
			);
		}
	}
}

export default DropdownSelection



// WEBPACK FOOTER //
// ./src/data/DropDown.js